.select {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0.5rem 0.625rem;
  border: 0.0625rem solid var(--neutral);
  border-radius: 0.5rem;
  color: var(--neutral-600);
  white-space: nowrap;
  cursor: pointer;
  background-color: var(--neutral);
  box-shadow: 0 0.0625rem 0.375rem -0.125rem rgba(var(--neutral-800-rgb), 0.3);

  &:hover {
    background-color: var(--neutral-50);
    border-color: var(--neutral-50);
  }

  &.ghost {
    box-shadow: none;
    padding-right: 0.125rem;

    &:not(:hover) {
      border-color: transparent;
      background-color: transparent;
    }
  }

  &.round {
    border-radius: 99rem;
  }

  &.rounded {
    border-radius: 1rem;
  }

  &.active {
    background-color: var(--neutral-50);

    .chevron {
      svg {
        transform: rotate(180deg);
      }
    }
  }

  .icon,
  .emoji {
    width: 2.5rem;
    height: 2.5rem;
    margin: 0 0.75rem 0 0;
    border-radius: 0.5rem;
    background-color: rgba(var(--primary-600-rgb), 0.125);
  }

  .icon,
  .emoji,
  .chevron {
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    align-items: center;

    svg {
      width: 1.375rem;
      height: 1.375rem;
    }
  }

  .chevron {
    width: 2rem;
    height: 2rem;

    svg {
      transition: 0.1s;
    }
  }
}
